import { ChartCardWithWidget } from 'src/components/overview/ChartCard'
import PaymentGatewaySuccessRate from 'src/components/overview/charts/PaymentsSection/PaymentGatewaySuccessRate'
import PaymentMethodsConversionRates from 'src/components/overview/charts/PaymentsSection/PaymentMethodsConversionRates'
import PaymentSplitPieChart from 'src/components/overview/charts/PaymentsSection/PaymentSplitPieChart'
import PrepaidShareChart from 'src/components/overview/charts/PaymentsSection/PrepaidShareChart'
import { CheckWidget } from 'src/components/overview/charts/common/CheckWidget'
import { WidgetId, WidgetSections } from 'src/lib/contexts/AnalyticsContext/types'
import CodOrdersConvertedToPrepaidTable from '../charts/DiscountSection/CodOrdersConvertedToPrepaidTable'

const PaymentsSection = () => {
  return (
    <div>
      {/* Charts */}
      <div className='space-y-6'>
        {/* Single Series Line Chart */}
        <div className='grid grid-cols-2 gap-4'>
          {/* Comparison Line Chart */}
          <CheckWidget widgetId={WidgetId.payment_split}>
            <ChartCardWithWidget widgetSection={WidgetSections.payments} widgetId={WidgetId.payment_split}>
              <PaymentSplitPieChart />
            </ChartCardWithWidget>
          </CheckWidget>
          <CheckWidget widgetId={WidgetId.payment_prepaid_share}>
            <ChartCardWithWidget widgetSection={WidgetSections.payments} widgetId={WidgetId.payment_prepaid_share}>
              <PrepaidShareChart />
            </ChartCardWithWidget>
          </CheckWidget>
          <CheckWidget widgetId={WidgetId.payment_methods_conversion_rates}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.payments}
              widgetId={WidgetId.payment_methods_conversion_rates}
            >
              <PaymentMethodsConversionRates />
            </ChartCardWithWidget>
          </CheckWidget>
          <CheckWidget widgetId={WidgetId.cod_orders_converted_to_prepaid}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.discounts}
              widgetId={WidgetId.cod_orders_converted_to_prepaid}
            >
              <CodOrdersConvertedToPrepaidTable />
            </ChartCardWithWidget>
          </CheckWidget>
          <CheckWidget widgetId={WidgetId.payment_gateways_success_rate}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.payments}
              widgetId={WidgetId.payment_gateways_success_rate}
            >
              <PaymentGatewaySuccessRate />
            </ChartCardWithWidget>
          </CheckWidget>
        </div>
      </div>
    </div>
  )
}

export default PaymentsSection
